import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { AlertController, NavController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { isNil } from 'lodash-es';
import { map, Observable } from 'rxjs';

import * as fromConfigSelectors from '../../../store/selectors/config.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-terms',
  standalone: false,
  templateUrl: './terms.page.html'
})
export class TermsPageComponent {
  private domSanitizer = inject(DomSanitizer);
  private alertController = inject(AlertController);
  private navController = inject(NavController);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private activatedRoute = inject(ActivatedRoute);
  private store = inject(Store);

  termDescription$: Observable<SafeHtml>;
  isOnboardingFlow = true;

  constructor() {
    this.isOnboardingFlow = !!this.activatedRoute.snapshot.data['isOnboardingFlow'];

    this.termDescription$ = this.store.pipe(
      select(fromConfigSelectors.selectTermDescription),
      map((termDescription) => {
        return this.domSanitizer.bypassSecurityTrustHtml(isNil(termDescription) ? 'N/A' : termDescription);
      })
    );
  }

  async onDecline() {
    const alert = await this.alertController.create({
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok'
        }
      ],
      header: 'Terms Declined',
      message: 'Use of the application requires acceptance of the Terms of Service'
    });

    await alert.present();
    this.changeDetectorRef.detectChanges();
  }
  async onAccept() {
    await this.navController.navigateForward(['onboarding', 'register']);
  }
}
